module.exports = __webpack_public_path__ + "e1a630e4c9a2de4455e23b350208d97f.png";